<h1>Clip-Nummern</h1>
<section class="article">
  <article>
    <div class="text">
      <p>
        Nach dem Erstellen und Bearbeiten eines Projekts, bietet die Software
        v2m beim Publizieren die Option an, die Clip-Nummern in der
        Video-Anleitung mit anzuzeigen.
      </p>
      <img class="screenshot" src="assets/show_clip_number.jpg" />
      <p>
        Die Clip-Nummern ermöglichen einerseits die Orientierung des Nutzers
        während der Anwendung. Die Anzeige der Clip-Nummern berücksichtigt aber
        auch die Anforderung nach einem internen Review oder einem Kundenreview.
        Clip-Nummern nummerieren in dieser Reihenfolge: Menüpunkt, Sequenz und
        Clip.
      </p>
      <img class="screenshot" src="assets/clip_with_number.jpg" />
      <p>
        Hier handelt es sich also um Clip 2 in der zweiten Sequenz im ersten
        Menüpunkt.
      </p>
      <p>
        So können Reviewanmerkung eindeutig zugeordnet werden, wie z. B. Clip
        2.2.1 soll noch einen Warnhinweis erhalten, Clip 1.3.2 zeigt das falsche
        Bedienelement, Clip 3.1.1 kann entfallen usw.<br/>Nach dem Umsetzen der
        Reviewanmerkungen im Projekt, kann die Video-Anleitung erneut publiziert
        werden. Dabei kann der neue Revisionsstand als Metadatum mit einfließen.
      </p>
    </div>
    <a [routerLink]="['/blog']" class="call">Zurück zur Übersicht</a>
  </article>
</section>
